module.exports = __webpack_public_path__ + "static/30-eb09f3a9798270590b59fbac62e0fd48.png";